import {
    ElNotification
} from 'element-plus';

export const notifError = (Error: any) => {
    const status = Error?.status ?? Error?.response?.status;
    const message = String(Error?.data?.message || Error?.response?.data?.message || '').toLowerCase();
    if (status === 401 && (
        message.includes('token expired')
        || message.includes('token not provided')
        || message.includes('unauthenticated')
        || message.includes('session expired')
        || message.includes('user categories not authentication')
    )) {
        return;
    }
    ElNotification.error({
        title: `Error (${Error?.status || 'N/A'})`,
        message: sanitizeCurlError(Error?.data?.message || Error?.message || 'Something went wrong'),
        duration: Error?.status ? 0 : 3000,
    });
}

/** Notify user which form fields failed validation (client or API 400). */
export const notifValidationFields = (messages: string[], title = 'Please complete required fields') => {
    const list = (messages || []).map((m) => String(m || '').trim()).filter(Boolean);
    if (!list.length) {
        ElNotification.error({
            title,
            message: 'Some fields are invalid. Please check the form.',
            duration: 6000,
        });
        return;
    }
    ElNotification.error({
        title,
        dangerouslyUseHTMLString: true,
        message: `<ul style="margin:0;padding-left:18px;">${list.map((m) => `<li>${escapeHtml(m)}</li>`).join('')}</ul>`,
        duration: 8000,
    });
}

const BOOKING_FIELD_LABELS: Record<string, string> = {
    'guest_booking.guest_prefix_id': 'Guest Prefix',
    'guest_booking.first_name': 'Guest First Name',
    'guest_booking.last_name': 'Guest Last Name',
    'guest_booking.national_id': 'Nationality',
    'guest_booking.identity_type_id': 'Identity Type',
    'guest_booking.identity_no': 'Identity No',
    'guest_booking.email': 'Guest Email',
    'guest_booking.phone': 'Guest Phone',
    'guest_booking.country_id': 'Country',
    'guest_booking.address': 'Address',
    'property_agent_id': 'Agent / Source',
    'booking_status_id': 'Booking Status',
    'booking_reference': 'Booking Reference',
    'payment_collect_type_id': 'Payment Collect',
    'arival': 'Arrival Date',
    'depature': 'Departure Date',
    'hold_date': 'Hold Date',
    'remark': 'Remark',
    'room_lists': 'Room Allocation',
};

/** Map Laravel validation bag to readable labels and show notification. */
export const notifApiValidationErrors = (err: any, fallbackMessage = 'Please input valid Data') => {
    const messages: string[] = [];
    if (err && typeof err === 'object' && !Array.isArray(err)) {
        Object.keys(err).forEach((key) => {
            const raw = Array.isArray(err[key]) ? err[key][0] : err[key];
            if (!raw) return;
            const label = BOOKING_FIELD_LABELS[key]
                || key.replace(/^guest_booking\./, 'Guest ').replace(/^room_lists\.\d+\./, 'Room ').replace(/_/g, ' ');
            const text = String(raw).replace(/ id /gi, ' ').replace(/guest booking\./gi, '');
            messages.push(`${label}: ${text}`);
        });
    }
    notifValidationFields(messages, fallbackMessage);
}

const escapeHtml = (value: string) =>
    value
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');

const sanitizeCurlError = (msg: any = "") => {
  if (!msg || typeof msg !== "string") return "Something went wrong";

  // Hapus bagian "(see ... for error code explanation)"
  let cleanMsg = msg.replace(/\(see.*for error code explanation\)/gi, "");
  // Hapus semua URL (baik statis maupun dinamis)
  cleanMsg = cleanMsg.replace(/https?:\/\/\S+/g, "");
  cleanMsg = cleanMsg.replace(/\(see for.*?\)/gi, "");
  // Rapikan spasi berlebih
  cleanMsg = cleanMsg.replace(/\s+/g, " ").trim();

  return cleanMsg;
}
